'use strict';

SortingPreprocessorFactory.$inject = ['mx.SolutionBuilderAgent.SortingGridPreprocessor', 'mx.sb.Agent.DataQuery.SortingPreprocessor'];
export default function SortingPreprocessorFactory(SortingGridPreprocessor, newSortingPreprocessorFactory) {
	class SortingPreprocessor extends SortingGridPreprocessor {
		constructor() {
			super();
			this.preprocessor = newSortingPreprocessorFactory();
			this.preprocessor.enableSingleColumnMode();
		}
	}

	return SortingPreprocessor;
}
